// 发货单相关
import httpClient from "@/services/http/mainServerClient";
import PackingListTemplateDTO from "@/dto/template/PackingListTemplateDTO";

interface CreateTemplateParams {
    /**是否自适应高度 */
    autoHeight: boolean;
    /**纸张两边是否带有孔位。 */
    hasPadding: boolean;
    /**模板名称 */
    name: string;
    width: number;
    height: number;
    /**打印方向，1：纵向固定高度；2：横向固定高度。 */
    orient: 1 | 2;
    /**纸张类型。 */
    pageType: string;
    picture?: Blob;
}

// 创建发货单模板
function createTemplate(params: CreateTemplateParams): Promise<PackingListTemplateDTO> {
    const formData = new FormData();

    Object.entries(params).forEach(([key, value]: any) => {
        if (value !== undefined) {
            formData.append(key, value);
        }
    });

    return httpClient.post(`/packingListTemplate`, formData, { timeout: 60000 });
}

interface CreateTemplateByQnParams {
    autoHeight: boolean;
    hasPadding: boolean;
    name: string;
    width: number;
    height: number;
    orient: number;
    pageType: string;
    pictureFileSize?: number;
    pictureOriginalName?: string;
    pictureUrl?: string;
}

function createTemplateByQn(params: CreateTemplateByQnParams) {
    return httpClient.post("/packingListTemplate/qianniu/packingListTemplate", params);
}

// 更新发货单模板
function updateTemplate(id: any, params: any) {
    return httpClient.post<PackingListTemplateDTO>(`/packingListTemplate/update/${id}`, params);
}

function getTemplate(id: any): Promise<PackingListTemplateDTO> {
    return httpClient.get(`/packingListTemplate/${id}`);
}

// 获取当前店铺的发货单模板列表
export function getTemplates(): Promise<PackingListTemplateDTO[]> {
    return httpClient.get(`/packingListTemplate/`);
}

// 获取系统发货单模板列表
function getSystemTemplates(): Promise<PackingListTemplateDTO[]> {
    return httpClient.get(`/packingListTemplate/system`);
}

// 复制系统发货单模板
function copySystemTemplate(id: any) {
    return httpClient.post(`/packingListTemplate/${id}:copySystem`);
}
// 复制当前店铺的发货单模板
function copyTemplate(id: any) {
    return httpClient.post(`/packingListTemplate/${id}:copy`);
}

// 发货单绑定店铺
function bindShop({ templateId, shopIds }: any) {
    return httpClient.post(`/packingListTemplate/${templateId}:bindShop`, {
        shopIds,
    });
}
// 发货单解绑店铺
function unbindShop(templateId: any) {
    return httpClient.post(`/packingListTemplate/${templateId}:unbindShop`);
}

// 删除发货单模板
function deleteTemplate(id: any) {
    return httpClient.post(`/packingListTemplate/delete/${id}`);
}

// 绑定打印机
function bindPrinter({ templateId, printer }: any) {
    return httpClient.post(`/packingListTemplate/${templateId}:bindPrinter`, {
        printer,
    });
}

// 取消绑定打印机
function unbindPrinter(templateId: any) {
    return httpClient.post(`/packingListTemplate/${templateId}:unbindPrinter`);
}

export function recoveryPackingListTemplate(id: number) {
    return httpClient.post(`/packingListTemplate/recovery/${id}`);
}

export default {
    createTemplate,
    createTemplateByQn,
    updateTemplate,
    getTemplate,
    getTemplates,
    getSystemTemplates,
    copyTemplate,
    copySystemTemplate,
    bindShop,
    unbindShop,
    deleteTemplate,
    bindPrinter,
    unbindPrinter,
};
